import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import Parse from 'parse'
import styled from 'styled-components'
import cssVar from '../../styles/variables'
import Modal from './Modal'
import { Text, SecondaryButton, BiggerText, Heading2, PrimaryButton, TextField, NoticeText, GridRow, Link } from './MarketingStyles';
import { withCookies, Cookies } from 'react-cookie';

import MultistepForm from '../onboarding/MultistepForm';
import checkmark from '../../images/icons/checkmark.svg'
import { inject, observer } from 'mobx-react'

import { trackEvent } from "../../utils/eventTracking"

import ReactGA from "react-ga";
import ReactPixel from 'react-facebook-pixel';
import TagManager from 'react-gtm-module'

@inject('modalStore')
@observer
class CookieModal extends Component {

  constructor(props) {
    super(props)
    this.state = {
      action: 'save'
    }
  }

  request = ( e ) => {
    e.preventDefault();
    const data = e.target
    const cookies = this.props.cookies;

    if(this.state.action == 'all') {
      cookies.set('cookies-accepted-stats', 1, { path: '/', maxAge: 60 * 60 * 24 * 365 });
      cookies.set('cookies-accepted-marketing', 1, { path: '/', maxAge: 60 * 60 * 24 * 365 });
    } else {
      cookies.set('cookies-accepted-stats', data.stats.checked ? 1 : 0, { path: '/', maxAge: 60 * 60 * 24 * 365 });
      cookies.set('cookies-accepted-marketing', data.marketing.checked ? 1 : 0, { path: '/', maxAge: 60 * 60 * 24 * 365 });
    }

    cookies.set('cookies-set', 1, { path: '/', maxAge: 60 * 60 * 24 * 365 });

    this.initMarketing();
    this.initStats();

    this.props.modalStore.setState('cookies', false)
    // trackEvent( 'Request Information - Freischalten - Button ', 'Advertisment', 'Form Submission' )
  }


  getCookieValue = (name) => {
    const val = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')
    return val ? val.pop() : ''
  }

  componentDidMount() {
    this.initMarketing();
    this.initStats();
  }

  initMarketing = () => {
    if( Number( this.getCookieValue('cookies-accepted-marketing') ) !== 1)  return

    console.log("loading marketing");

    const isProd = process.env.NODE_ENV === "production"
    ReactPixel.init('172535441307405', {}, { debug: !isProd });

  }

  initStats = () => {
    if( Number( this.getCookieValue('cookies-accepted-stats') ) !== 1)  return

    console.log("loading stats");

    // const isProd = process.env.NODE_ENV === "production"
    // ReactGA.initialize("GTM-T7FNR67", { debug: !isProd, testMode: false });
    // ReactGA.set({ page: this.props.history.location.pathname });
    // ReactGA.pageview(this.props.history.location.pathname);

    const tagManagerArgs = {
        gtmId: 'GTM-T7FNR67'
    }

    TagManager.initialize(tagManagerArgs)
  }

  render() {
    return (
      <Modal slug="cookies" unclosable={ true }>
        <Heading2>Cookie Präferenzen</Heading2>
        <Text>
          Diese Website verwendet Cookies. Selbstverständlich können Sie hier angeben, welche Sie davon zulassen möchten. <Link href="/datenschutz">Mehr Informationen</Link>
        </Text>
        <form onSubmit={ (e) => this.request(e) }>

          <SelectionItem>
            <SelectionItemTitle>Technisch</SelectionItemTitle>
            <SelectionItemCheckbox name="technical" checked={ true } disabled={ true } />
          </SelectionItem>

          <SelectionItem>
            <SelectionItemTitle>Statistisch</SelectionItemTitle>
            <SelectionItemCheckbox name="stats"/>
          </SelectionItem>
          <SelectionItem>

            <SelectionItemTitle>Marketing</SelectionItemTitle>
            <SelectionItemCheckbox name="marketing"/>
          </SelectionItem>


          <GridRow desktop="1fr 1fr" phone="100%" phoneRowGap style={{marginTop: 20}}>

            <SecondaryButton
              value="Auswahl speichern"
              onClick={ e => { this.setState({ action: 'save' }) }}
              name="ave"
            />
            <PrimaryButton
              value="alle akzeptieren"
              onClick={ e => { this.setState({ action: 'all' }) }}
              name="action"
            />
          </GridRow>

        </form>
      </Modal>
    )
  }
}

export default withCookies(withRouter(CookieModal))

const SelectionItem = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const SelectionItemTitle = styled(Text) `

`

const SelectionItemCheckbox = styled.input.attrs({ type: 'checkbox' }) `

`



// WEBPACK FOOTER //
// /src/components/marketing/CookieModal.js